import React from 'react';

import { mString, pString } from 'lib/helpers/utility';

import DetailsCell from '../cells/DetailsCell';

export const DEFAULT_COL_DEFS = {
  cellClass: 'no-border break-word-cell',
  enableRowGroup: true,
  resizable: true,
  filter: false,
  suppressMenu: true,
  suppressMovable: true,
  flex: 1,
  minWidth: 80,
  autoHeight: true,
  editable: false,
  wrapText: true
};

export const GRID_OPTIONS = {
  domLayout: 'autoHeight',
  animateRows: true,
  rowGroupPanelShow: 'always'
};

export const INVOICE_COLUMN_DEFS = (isMobile) => [
  {
    headerName: 'Service Description',
    field: 'details',
    minWidth: 240,
    cellClass: 'min-w-[240px]',
    cellRenderer: (params) => <DetailsCell {...params} key="details" />
  },
  ...(!isMobile
    ? [
        {
          headerName: 'CPT® Code',
          field: 'procedure_code'
        },
        {
          headerName: 'Diagnosis Code',
          field: 'diagnosis_code'
        }
      ]
    : []),
  {
    headerName: 'Provider’s Charge',
    field: 'charge',
    valueFormatter: ({ value }) => mString(value ?? 0),
    aggFunc: 'sum'
  },
  {
    headerName: 'Adjust. / Discount',
    field: 'discount',
    valueFormatter: ({ value }) => mString(value?.amount_cents ?? 0),
    aggFunc: 'sum'
  },
  {
    headerName: 'Allowed Amount',
    field: 'allowed_amount',
    valueFormatter: ({ value }) => mString(value ?? 0),
    aggFunc: 'sum'
  },
  {
    headerName: 'Insurance Pays',
    field: 'ins_payment',
    valueFormatter: ({ value }) => mString(value ?? 0),
    aggFunc: 'sum'
  },
  {
    headerName: 'Deductible',
    field: 'deductible',
    valueFormatter: ({ value }) => mString(value ?? 0),
    aggFunc: 'sum'
  },
  {
    headerName: 'Copay',
    field: 'copay',
    valueFormatter: ({ value }) => mString(value ?? 0),
    aggFunc: 'sum'
  },
  {
    headerName: 'Coins.',
    field: 'co_insurance',
    valueFormatter: ({ value }) => mString(value ?? 0),
    aggFunc: 'sum'
  },
  {
    headerName: 'Local Tax',
    field: 'local_tax_rate',
    valueFormatter: ({ value }) => pString(value ?? 0),
    aggFunc: 'sum'
  },
  {
    headerName: 'State Tax',
    field: 'state_tax_rate',
    valueFormatter: ({ value }) => pString(value ?? 0),
    aggFunc: 'sum'
  },
  {
    headerName: 'Total Pt. Respons.',
    field: 'ptBalance',
    valueFormatter: ({ value }) => mString(value ?? 0),
    aggFunc: 'sum'
  }
];
